import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { isNullUndefinedOrEmpty } from "../../../common/Helpers";
import { useOfGetDailyIntegrationReport } from "../../../hooks/services/sIntegration/useOfIntegration";
import Loading from "../../../components/Templates/Site/Loading";
import { t } from 'i18next';

const VisorSevenDayReport = () => {
    const [series, setSeries] = useState(null);

    const [options, setOptions] = useState({
        chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
                show: true,
            },
            zoom: {
                enabled: true,
            },
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                legend: {
                    position: "bottom",
                    offsetX: -10,
                    offsetY: 0,
                },
                },
            },
        ],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "last",
                dataLabels: {
                    total: {
                        enabled: false,
                    },
                },
            },
        },
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            offsetY: 10,
        },
        fill: {
            opacity: 1,
        },
    });

    useOfGetDailyIntegrationReport(series, setSeries);

    return (
            <Card className="mx-auto" style={{width: "80%"}}>
                <Card.Body id="chart">
                    <h4>{t('data-lang-boxname-integration-sevendaysvisorreport')}</h4>
                    {
                        !isNullUndefinedOrEmpty(series) && series.length > 0 &&
                        <ReactApexChart
                            options={options}
                            series={series}
                            type="bar"
                            height={200}
                        />
                    }
                    {
                        isNullUndefinedOrEmpty(series) && 
                        <Loading inputParam_ShowLoading={true} />
                    }
                </Card.Body>
            </Card>
    );
};

export default VisorSevenDayReport;